/* Manu AI v18 (22/10/2026) — écrans qui glissent à la place du chat, une fois le design dessiné.
 * - Le chat ne sert plus qu'à discuter (idée, questions, retouche libre, chargement). Dès qu'un résultat existe,
 *   on reste sur un écran : 1. Design (aperçu générique devant / dos) → 2. Vêtement (éditeur sur la photo) → fiche de personnalisation.
 *   Le changement d'écran glisse (transform + opacité, sans animation si « réduire les animations »).
 * - « OK pour ce design » glisse vers le vêtement ; « Continuer la personnalisation » range les fichiers, puis ouvre la fiche
 *   (le récapitulatif en chat disparaît) ; « Modifier le design » revient en arrière sans rien perdre.
 * - Boutons permanents sous le design : Décliner pour une autre personne, Copier le lien, retouches rapides, autre demande (chat).
 *   « Décliner » et « Refaire » ouvrent un petit formulaire sur l'écran (plus de questions dans le chat).
 * - Garde-fou : tout message de Manu ou chargement repasse automatiquement en vue chat.
 * S'appuie sur l'instance de assets/ai-studio.js (section._ais), enrichie par v9 → v17, chargés avant. */
(function () {
  'use strict';

  var TXT = {
    fr: { back: 'Modifier le design', retouch: 'Retoucher', other: 'Autre demande', backChat: 'Revenir au mockup', cancel: 'Fermer', create: 'Créer ce design',
      redoAsk: 'Qu’est-ce que tu veux changer sur le {side} ?', colors: 'Autres couleurs', simple: 'Plus simple', text: 'Changer le texte', all: 'Tout refaire',
      phText: 'Nouveau texte', phFree: 'Décris ta retouche en une phrase', apply: 'Appliquer', phName: 'Nom ou texte pour cette personne', phIdea: 'Décris ce qui change', changes: 'Ce qui change', side: 'Sur quelle face' },
    en: { back: 'Edit the design', retouch: 'Tweak', other: 'Something else', backChat: 'Back to the mockup', cancel: 'Close', create: 'Create this design',
      redoAsk: 'What do you want to change on the {side}?', colors: 'Other colours', simple: 'Simpler', text: 'Change the text', all: 'Redo everything',
      phText: 'New text', phFree: 'Describe your tweak in one sentence', apply: 'Apply', phName: 'Name or text for this person', phIdea: 'Describe what changes', changes: 'What changes', side: 'On which side' },
    es: { back: 'Modificar el diseño', retouch: 'Retocar', other: 'Otra petición', backChat: 'Volver al mockup', cancel: 'Cerrar', create: 'Crear este diseño',
      redoAsk: '¿Qué quieres cambiar de la cara «{side}»?', colors: 'Otros colores', simple: 'Más simple', text: 'Cambiar el texto', all: 'Rehacer todo',
      phText: 'Texto nuevo', phFree: 'Describe tu retoque en una frase', apply: 'Aplicar', phName: 'Nombre o texto para esta persona', phIdea: 'Describe qué cambia', changes: 'Qué cambia', side: 'En qué cara' },
    de: { back: 'Entwurf ändern', retouch: 'Anpassen', other: 'Andere Bitte', backChat: 'Zurück zum Mockup', cancel: 'Schließen', create: 'Diesen Entwurf erstellen',
      redoAsk: 'Was soll ich bei „{side}“ ändern?', colors: 'Andere Farben', simple: 'Einfacher', text: 'Text ändern', all: 'Alles neu',
      phText: 'Neuer Text', phFree: 'Beschreibe die Änderung in einem Satz', apply: 'Anwenden', phName: 'Name oder Text für diese Person', phIdea: 'Beschreibe, was sich ändert', changes: 'Was sich ändert', side: 'Auf welcher Seite' },
    it: { back: 'Modifica il design', retouch: 'Ritocca', other: 'Altra richiesta', backChat: 'Torna al mockup', cancel: 'Chiudi', create: 'Crea questo design',
      redoAsk: 'Cosa vuoi cambiare sul lato «{side}»?', colors: 'Altri colori', simple: 'Più semplice', text: 'Cambia il testo', all: 'Rifai tutto',
      phText: 'Nuovo testo', phFree: 'Descrivi il ritocco in una frase', apply: 'Applica', phName: 'Nome o testo per questa persona', phIdea: 'Descrivi cosa cambia', changes: 'Cosa cambia', side: 'Su quale lato' }
  };
  var IC = {
    back: '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M19 12H5M11 6l-6 6 6 6"/></svg>',
    users: '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="9" cy="8" r="3.5"/><path d="M2.5 20c.6-3.6 3.2-5.5 6.5-5.5s5.9 1.9 6.5 5.5"/><path d="M16 4.6a3.5 3.5 0 0 1 0 6.8M18 14.8c2 .7 3.2 2.3 3.5 5.2"/></svg>',
    link: '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M10 13a5 5 0 0 0 7.07 0l3-3a5 5 0 0 0-7.07-7.07l-1.5 1.5"/><path d="M14 11a5 5 0 0 0-7.07 0l-3 3A5 5 0 0 0 11 21.07l1.5-1.5"/></svg>',
    chev: '<svg class="ais-v18__chev" viewBox="0 0 16 16" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 6l4 4 4-4"/></svg>',
    chat: '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M21 12a8 8 0 0 1-11.7 7.1L4 20l1-4.6A8 8 0 1 1 21 12z"/></svg>'
  };

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function rep(s, o) { return String(s).replace(/\{(\w+)\}/g, function (m, k) { return o[k] != null ? o[k] : m; }); }

  function enhance(root) {
    var inst = root._ais;
    if (!inst || inst._v18 || !inst._v17 || !inst._v15) return;
    inst._v18 = true;
    var dlg = inst.dialog, view = 'chat', mode = null, stage = null, pn = null;
    function tx() { return TXT[inst.loc] || TXT.fr; }
    function sideName(k) { return String(inst.t.sides[k] || k); }
    function reduced() { return !!inst.reduce; }

    /* ---------- Vue : chat ou écran ---------- */
    function setView(v) {
      view = v; dlg.setAttribute('data-view', v);
      if (v === 'chat') inst.scroll();
    }
    function makeStage() {
      stage = document.createElement('div');
      stage.className = 'ais-v18'; stage.setAttribute('aria-live', 'off');
      inst.thread.appendChild(stage);
      mode = null; pn = null;
    }
    makeStage(); setView('chat');
    inst.say = function (text) {
      var n = view === 'stage' && stage.querySelector('[data-s18-note]');
      if (n) { n.textContent = text; n.hidden = false; n.scrollIntoView({ block: 'nearest', behavior: reduced() ? 'auto' : 'smooth' }); return Promise.resolve(); }
      return this.bot(esc(text));
    };

    /* ---------- Garde-fous : le chat reprend la main dès que Manu parle ---------- */
    var baseBot = inst.bot;
    inst.bot = function () { if (view === 'stage') setView('chat'); return baseBot.apply(this, arguments); };
    var baseUser = inst.user;
    inst.user = function () { if (view === 'stage') return; return baseUser.apply(this, arguments); };
    var baseLoader = inst.startLoader;
    inst.startLoader = function () { if (view === 'stage') setView('chat'); return baseLoader.apply(this, arguments); };
    var baseReset = inst.reset;
    inst.reset = function () { var r = baseReset.apply(this, arguments); makeStage(); setView('chat'); return r; };

    /* ---------- Écrans ---------- */
    function isSupportScreen(pane) { return !!inst.s.designOk && (!!pane.querySelector('[data-v11-stage]') || pane.hasAttribute('data-plain')); }

    // Couleurs : seulement celles du vêtement choisi (la palette de base réunit tous les vêtements du sport)
    var basePalette = inst.palette;
    inst.palette = function () {
      var pal = basePalette.apply(this, arguments), sp = this.s.designOk && this.s.support;
      if (sp && sp.colors && sp.colors.length) {
        var keys = sp.colors.map(function (c) { return String(c.n || '').trim().toLowerCase(); });
        var f = pal.filter(function (c) { return keys.indexOf(c.k) > -1; });
        if (f.length) return f;
      }
      return pal;
    };

    // Vêtement sans photo de variante : choix du produit, couleur et lien vers Teeinblue sur le même écran
    function plainSupport(pane) {
      var s = inst.s, res = pane.querySelector('[data-result]'), list = inst.supportsFor(s.niche);
      if (!list.length) return false;
      var sp = s.support && list.indexOf(s.support) > -1 ? s.support : list[0];
      s.support = sp;
      pane.setAttribute('data-plain', '');
      var short = function (t) { return String(t || '').split(' (')[0].replace(/\s+À PERSONNALISER$/i, ''); };
      res.className = 'ais-result ais-result--stack';
      res.innerHTML = '<div data-mockbox>' + inst.mock(sp, s.color, true, true) + '</div>' +
        '<div class="ais-result__body"><p class="ais-v18__lbl">' + esc(inst.t.step_support || '') + '</p>' +
        '<div class="ais-pn__g" role="group" aria-label="' + esc(inst.t.step_support || '') + '">' + list.map(function (x) {
          return '<button type="button" class="ais-v18__btn ais-v18__btn--sm" data-s18-sup="' + inst.supports.indexOf(x) + '" aria-pressed="' + (x === sp) + '"><span>' + esc(x.short || short(x.t)) + '</span><b>' + esc(x.price) + '</b></button>';
        }).join('') + '</div>' + inst.swatches() + (inst.delayLine ? inst.delayLine(sp.price) : '') +
        '<div class="ais-actions"><a class="ais-btn ais-btn--primary" href="' + esc(inst.handoffUrl()) + '" data-act="handoff" data-s18-go>' + esc(inst.t.cta_custom) + '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6"/></svg></a></div></div>';
      return true;
    }

    // Sur l'aperçu du thème draft, la fiche produit doit s'ouvrir dans le même aperçu (sinon thème live, sans dépôt du logo)
    var baseUrl = inst.handoffUrl;
    inst.handoffUrl = function () {
      var u = baseUrl.apply(this, arguments), m = /[?&]preview_theme_id=(\d+)/.exec(location.search);
      return m && u.indexOf('preview_theme_id=') < 0 ? u + (u.indexOf('?') > -1 ? '&' : '?') + 'preview_theme_id=' + m[1] : u;
    };

    // « Valider » de l'éditeur devient directement le lien vers la fiche de personnalisation (refait après chaque redessin : vêtement ou couleur cliqué)
    function linkCta(res) {
      var s = inst.s, keep = res && res.querySelector('[data-act="keep"]');
      if (!keep || !s.support || !s.support.url) return;
      var a = document.createElement('a');
      a.className = keep.className; a.href = inst.handoffUrl(); a.setAttribute('data-act', 'handoff'); a.setAttribute('data-s18-go', '');
      a.innerHTML = esc(inst.t.cta_custom) + keep.innerHTML.replace(/^[^<]*/, '');
      keep.replaceWith(a);
    }
    var baseRender = inst.renderResult;
    inst.renderResult = function () {
      var r = baseRender.apply(this, arguments), res = this.resultEl;
      if (this.s.designOk && res && res.querySelector('[data-v11-stage]')) linkCta(res);
      // v28 : un nouveau rendu de l'écran du design (zoom, face, retrait…) efface les actions ajoutées dessous : on les remet (le bouton Retoucher disparaissait)
      inst.redecorate(res);
      return r;
    };
    inst.redecorate = function (res) {
      var pane = res && res.closest && res.closest('.ais-v18__pane');
      if (pane && pane.getAttribute('data-screen') === 'design' && !pane.querySelector('.ais-v18__acts') && !isSupportScreen(pane)) decorate(pane);
    };

    function decorate(pane) {
      var s = inst.s, T = tx(), res = pane.querySelector('[data-result]'), extra = pane.querySelector('[data-s18-extra]');
      var sup = isSupportScreen(pane);
      pane.setAttribute('data-screen', sup ? 'support' : 'design');
      if (sup) {
        // Écran 2 : retour au design, et « Valider » devient directement le lien vers la fiche de personnalisation
        pane.insertAdjacentHTML('afterbegin', '<button type="button" class="ais-v18__back" data-s18="back">' + IC.back + '<span>' + esc(T.back) + '</span></button>');
        linkCta(res);
        extra.innerHTML = '<div class="ais-pn" data-s18-panel hidden></div><p class="ais-v18__note" role="status" data-s18-note hidden></p>' + (inst.v28info ? inst.v28info() : '');
        return;
      }
      // Écran 1 : actions permanentes sous « OK pour ce design »
      var body = res.querySelector('.ais-result__body'), canAi = inst.canDecline && inst.canDecline(), tw = inst.t.tweaks || {}, own = s.path === 'own';
      var html = '<div class="ais-v18__acts">';
      if (canAi) {
        // Hiérarchie : un seul bouton plein (OK pour ce design), les autres actions en liens discrets, retouches repliées
        var barOn = inst.bk && inst.bk.designs.length > 1;
        if (s.idea && !own) {
          html += '<details class="ais-v18__tw"><summary class="ais-v18__lnk">' + esc(T.retouch) + IC.chev + '</summary><div class="ais-v18__chips">' +
            ['minimal', 'funny', 'text'].filter(function (v) { return tw[v] && !(v === 'minimal' && s.style === 'minimal'); }).map(function (v) {
              return '<button type="button" class="ais-v18__btn ais-v18__btn--sm" data-s18="tweak" data-v="' + v + '">' + esc(tw[v]) + '</button>';
            }).join('') +
            '<button type="button" class="ais-v18__btn ais-v18__btn--sm" data-s18="ask">' + IC.chat + '<span>' + esc(T.other) + '</span></button></div></details>';
        }
        html += '<div class="ais-v18__links">' +
          '<button type="button" class="ais-v18__lnk" data-s18="decl">' + IC.users + '<span>' + esc(inst.dtx().decl) + '</span></button>' +
          (barOn ? '' : '<button type="button" class="ais-v18__lnk" data-s18="share">' + IC.link + '<span>' + esc(inst.dtx().share) + '</span></button>') + '</div>';
      }
      if (own) html += '<div class="ais-v18__row"><button type="button" class="ais-v18__btn" data-s18="toai">' + esc(inst.t.own_ai) + '</button></div>';
      html += '<div class="ais-pn" data-s18-panel hidden></div><p class="ais-v18__note" role="status" data-s18-note hidden></p></div>';
      if (body) { body.querySelectorAll('p.ais-note:not([data-quality])').forEach(function (n) { n.remove(); }); body.insertAdjacentHTML('beforeend', html); } else extra.innerHTML = html;
    }

    // Affiche l'écran courant (design ou vêtement) ; glisse si on change d'écran
    function show() {
      var old = stage.querySelector('.ais-v18__pane'), T = tx();
      var pane = document.createElement('section');
      pane.className = 'ais-v18__pane'; pane.tabIndex = -1;
      pane.innerHTML = '<div class="ais-result ais-result--stack" data-result></div><div data-s18-extra></div>';
      stage.appendChild(pane);
      inst.resultEl = pane.querySelector('[data-result]');
      pn = null;
      inst.renderResult();
      // Sans photo pour ce vêtement : même écran, version simple (produit, couleur, lien Teeinblue)
      if (inst.s.designOk && !pane.querySelector('[data-v11-stage]') && !plainSupport(pane)) {
        pane.remove(); if (old) old.remove(); inst.resultEl = null; mode = null;
        setView('chat'); inst.flow(); return;
      }
      var sup = isSupportScreen(pane);
      decorate(pane);
      var now = sup ? 'b' : 'a', dir = mode === 'a' && now === 'b' ? 1 : (mode === 'b' && now === 'a' ? -1 : 0);
      mode = now;
      inst.setStep(sup ? 'support' : 'design');
      setView('stage');
      inst.thread.scrollTop = 0;
      if (old) {
        old.setAttribute('aria-hidden', 'true'); old.setAttribute('inert', ''); old.classList.add('is-out');
        if (reduced() || !old.animate) old.remove();
        else {
          var ease = 'cubic-bezier(.16, 1, .3, 1)', dx = 56 * (dir || 0);
          var out = old.animate([{ opacity: 1, transform: 'none' }, { opacity: 0, transform: 'translateX(' + (-dx) + 'px)' }], { duration: dir ? 320 : 160, easing: ease, fill: 'forwards' });
          out.onfinish = function () { old.remove(); };
          pane.animate([{ opacity: 0, transform: dir ? 'translateX(' + dx + 'px)' : 'none' }, { opacity: 1, transform: 'none' }], { duration: dir ? 420 : 220, easing: ease });
        }
      }
      pane.focus({ preventScroll: true });
    }
    // v24 : l'écran unifié pilote la vue (chat ⇄ mockup) et affiche l'écran même avant le premier dessin
    inst.setView = setView; inst.stageShow = show; inst.getView = function () { return view; };
    inst.hasStage = function () { return !!stage.querySelector('.ais-v18__pane'); };
    inst.showResult = function () {
      var s = this.s;
      s.pending = 'result';
      this.replyField.placeholder = s.path === 'own' ? this.t.composer_ph : this.t.retouch_ph;
      show();
      if (this.saveDesign) this.saveDesign();
      if (this.afterResult) this.afterResult();
    };
    // v13 : « OK pour ce design » → écran Vêtement (plus de bulles de chat)
    inst.toSupport = function () {
      var s = this.s;
      s.designOk = true; s.support = null; s.pending = null;
      show();
    };

    /* ---------- Boutons des écrans ---------- */
    function host() { return stage.querySelector('.ais-v18__pane:not(.is-out) [data-s18-panel]'); }
    function closePanel() { var h = host(); if (h) { h.hidden = true; h.innerHTML = ''; } pn = null; }
    function openPanel(kind, side) {
      var h = host(); if (!h) return;
      var s = inst.s;
      var sides = inst.manuSides ? inst.manuSides() : [];
      pn = kind === 'decl' ? { kind: 'decl', k: null, side: sides.indexOf(s.edit) > -1 ? s.edit : (sides[0] || 'front'), text: '' } : { kind: 'redo', side: side, mode: 'free', text: '' };
      drawPanel(); h.hidden = false;
      var f = h.querySelector('input'); if (f && window.matchMedia('(min-width: 750px)').matches) f.focus({ preventScroll: true });
      h.scrollIntoView({ block: 'nearest', behavior: reduced() ? 'auto' : 'smooth' });
    }
    function drawPanel() {
      var h = host(), T = tx(), D = inst.dtx(); if (!h || !pn) return;
      var sides = inst.manuSides();
      var btn = function (attrs, label, on) { return '<button type="button" class="ais-v18__btn ais-v18__btn--sm" ' + attrs + ' aria-pressed="' + !!on + '">' + esc(label) + '</button>'; };
      var html;
      if (pn.kind === 'decl') {
        var needText = pn.k && pn.k !== 'colors', ok = pn.k && (!needText || pn.text.trim());
        html = '<p class="ais-pn__t">' + esc(D.decl) + '</p>' +
          '<div class="ais-pn__g" role="group" aria-label="' + esc(T.changes) + '">' + btn('data-s18-k="text"', D.kText, pn.k === 'text') + btn('data-s18-k="colors"', D.kColors, pn.k === 'colors') + btn('data-s18-k="idea"', D.kIdea, pn.k === 'idea') + '</div>' +
          (sides.length > 1 ? '<div class="ais-pn__g" role="group" aria-label="' + esc(T.side) + '">' + sides.map(function (k) { return btn('data-s18-sd="' + k + '"', sideName(k), pn.side === k); }).join('') + btn('data-s18-sd="both"', D.both, pn.side === 'both') + '</div>' : '') +
          (needText ? '<input class="ais-pn__f" type="text" maxlength="300" autocomplete="off" data-s18-txt placeholder="' + esc(pn.k === 'text' ? T.phName : T.phIdea) + '" aria-label="' + esc(pn.k === 'text' ? T.phName : T.phIdea) + '" value="' + esc(pn.text) + '">' : '') +
          '<div class="ais-pn__a"><button type="button" class="ais-btn ais-btn--primary" data-s18-run' + (ok ? '' : ' disabled') + '>' + esc(T.create) + '</button><button type="button" class="ais-btn ais-btn--ghost" data-s18-close>' + esc(T.cancel) + '</button></div>';
      } else {
        html = '<p class="ais-pn__t">' + esc(rep(T.redoAsk, { side: sideName(pn.side).toLowerCase() })) + '</p>' +
          '<div class="ais-pn__g"><button type="button" class="ais-v18__btn ais-v18__btn--sm" data-s18-q="colors">' + esc(T.colors) + '</button><button type="button" class="ais-v18__btn ais-v18__btn--sm" data-s18-q="simple">' + esc(T.simple) + '</button>' +
          btn('data-s18-q="text"', T.text, pn.mode === 'text') + '<button type="button" class="ais-v18__btn ais-v18__btn--sm" data-s18-q="all">' + esc(T.all) + '</button></div>' +
          '<div class="ais-pn__r"><input class="ais-pn__f" type="text" maxlength="300" autocomplete="off" data-s18-txt placeholder="' + esc(pn.mode === 'text' ? T.phText : T.phFree) + '" aria-label="' + esc(pn.mode === 'text' ? T.phText : T.phFree) + '" value="' + esc(pn.text) + '">' +
          '<button type="button" class="ais-btn ais-btn--primary" data-s18-apply' + (pn.text.trim() ? '' : ' disabled') + '>' + esc(T.apply) + '</button></div>' +
          '<div class="ais-pn__a"><button type="button" class="ais-btn ais-btn--ghost" data-s18-close>' + esc(T.cancel) + '</button></div>';
      }
      h.innerHTML = html;
    }
    function applyRedo(text) {
      var E = inst.editPrompts, side = pn.side, t = String(text).trim();
      closePanel();
      inst.applyEdit(side, pn.mode === 'text' ? E.text(t.slice(0, 40)) : t);
    }

    // Les écouteurs sont posés sur le fil (le stage est recréé à chaque reset)
    inst.thread.addEventListener('click', function (e) {
      var b = e.target.closest('[data-s18], [data-s18-sup], [data-s18-k], [data-s18-sd], [data-s18-q], [data-s18-run], [data-s18-apply], [data-s18-close], [data-s18-go]');
      if (!b || !stage.contains(b)) return;
      var s = inst.s, T = tx();
      if (b.hasAttribute('data-s18-go')) {
        e.preventDefault(); e.stopPropagation();
        if (inst.busy || b.getAttribute('aria-busy')) return;
        b.setAttribute('aria-busy', 'true');
        if (inst.track && s.support) inst.track('support_ok', { product: s.support.h, color: s.color });
        inst.saveFaces().then(function () { inst.handoff(); location.assign(b.href); }, function () { b.removeAttribute('aria-busy'); });
        return;
      }
      if (inst.busy) return;
      if (b.hasAttribute('data-s18-sup')) {
        var pane = b.closest('.ais-v18__pane');
        s.support = inst.supports[+b.getAttribute('data-s18-sup')];
        if (pane) plainSupport(pane);
        return;
      }
      var act = b.getAttribute('data-s18');
      if (act === 'back') { s.designOk = false; inst.showResult(); return; }
      if (act === 'decl') { if (pn && pn.kind === 'decl') closePanel(); else openPanel('decl'); return; }
      if (act === 'share') { inst.shareLink(); return; }
      if (act === 'tweak') { setView('chat'); inst.command('tweak', b.getAttribute('data-v'), b.textContent.trim()); return; }
      if (act === 'ask') {
        setView('chat'); s.pending = 'result'; inst.quick.innerHTML = '';
        inst.chips([{ cmd: 's18-back', l: T.backChat, ghost: true }]);
        if (inst.replyField) inst.replyField.focus({ preventScroll: true });
        return;
      }
      if (act === 'toai') { inst.command('to-ai'); return; }
      if (!pn) return;
      if (b.hasAttribute('data-s18-close')) { closePanel(); return; }
      if (pn.kind === 'decl') {
        if (b.hasAttribute('data-s18-k')) { pn.k = b.getAttribute('data-s18-k'); drawPanel(); var f = host().querySelector('input'); if (f) f.focus({ preventScroll: true }); }
        else if (b.hasAttribute('data-s18-sd')) { pn.side = b.getAttribute('data-s18-sd'); drawPanel(); }
        else if (b.hasAttribute('data-s18-run') && !b.disabled) {
          inst.dc = { kind: pn.k, side: pn.side, text: pn.text.trim() };
          closePanel(); inst.launchDecline();
        }
        return;
      }
      // Refaire : raccourcis, texte ou phrase libre
      var q = b.getAttribute('data-s18-q'), E = inst.editPrompts;
      if (q === 'colors' || q === 'simple') { var sd = pn.side; closePanel(); inst.applyEdit(sd, E[q] || E.colors); }
      else if (q === 'text') { pn.mode = 'text'; drawPanel(); var f2 = host().querySelector('input'); if (f2) f2.focus({ preventScroll: true }); }
      else if (q === 'all') { var sd2 = pn.side; closePanel(); inst.lockThread(); inst.resultEl = null; inst.generateFaces([sd2], true); }
      else if (b.hasAttribute('data-s18-apply') && !b.disabled) applyRedo(pn.text);
    });
    inst.thread.addEventListener('input', function (e) {
      var f = e.target.closest('[data-s18-txt]'); if (!f || !pn) return;
      pn.text = f.value;
      var go = host().querySelector('[data-s18-run], [data-s18-apply]');
      if (go) go.disabled = !pn.text.trim();
    });
    inst.thread.addEventListener('keydown', function (e) {
      var f = e.target.closest && e.target.closest('[data-s18-txt]');
      if (f && e.key === 'Enter' && pn) { e.preventDefault(); var go = host().querySelector('[data-s18-run], [data-s18-apply]'); if (go && !go.disabled) go.click(); }
      if (e.key === 'Escape' && pn && host() && host().contains(e.target)) { e.preventDefault(); e.stopPropagation(); closePanel(); }
    });

    // « Refaire » (barre sur l'aperçu) : formulaire sur l'écran pour un design de Manu
    var baseRedo = inst.redoFace;
    inst.redoFace = function (side) {
      var f = this.s.faces[side];
      if (view === 'stage' && this.endpoint && f && f.src && !f.own && !f.mock && host()) { openPanel('redo', side); return; }
      return baseRedo.apply(this, arguments);
    };
    // Chat : retour à l'écran
    var baseCommand = inst.command;
    inst.command = function (cmd) {
      if (cmd === 's18-back') { this.quick.innerHTML = ''; this.s.pending = null; if (stage.querySelector('.ais-v18__pane')) { setView('stage'); } else this.showResult(); return; }
      return baseCommand.apply(this, arguments);
    };
  }

  function boot() { document.querySelectorAll('[data-ais]').forEach(enhance); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function () { setTimeout(boot, 0); });
})();
